import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import ReactDOM from "react-dom";
import { usePortal } from "../hooks/usePortal";
import { uuid } from "../utils/uuid";
import styles from "./ModalPortal.module.scss";
const portalId = `modals-${uuid()}`;

export const Modal = ({ children }: any) => {
  let modalStyles = styles.modalContainer;
  if (children.props.type === 'formModal') {
    modalStyles = styles.formModal;
  }
  if (children.props.type === 'moreInfoModal') {
    modalStyles = styles.moreInfoModal;
  }
  return (
    <div className={modalStyles}>
      {children}
    </div>
  );
};

export const ModalPortal = forwardRef(({ children, zIndex }: any, ref) => {
  const [show, setShow] = useState<any>(false);

  const portalContainer = usePortal({
    element: "div",
    id: portalId,
    style: `position: fixed;
    z-index:${zIndex ? zIndex : 98};
    `,
  });

  const actionPlaceholder = children?.props?.actionPlaceholder;

  useEffect(() => {
    const handler = (event: any) => {
      if (event.keyCode === 27 && actionPlaceholder !== 'notCloseOnClickOutside') {
        setShow(false);
      }
    };

    document.addEventListener("keydown", handler);

    return () => document.removeEventListener("keydown", handler);
  }, [actionPlaceholder]);

  // Used to call add message from the component implementing it
  // using a ref, like:
  // toastRef.current.addMessage({ mode, message: text });
  useImperativeHandle(ref, () => ({
    show(value: any) {
      setShow(value);
    },
  }));

  const handleClick = (e: any) => {
    if (
      e.target === e.currentTarget &&
      children.props.actionPlaceholder !== 'notCloseOnClickOutside'
    ) {
      setShow(false)
    }
  }

  return portalContainer ? (
    ReactDOM.createPortal(
      <>
        {show && (
          <div
            className={styles.modalBackdrop}
            role="button"
            tabIndex={-1}
            onClick={handleClick}
            onKeyDown={(e) => {
              if (
                e.target === e.currentTarget &&
                (e.key === "Enter" || e.key === " ") &&
                children.props.actionPlaceholder !== 'notCloseOnClickOutside'
              ) {
                e.preventDefault();
                setShow(false);
              }
            }}
          >
            <Modal>{children}</Modal>
          </div>
        )}
      </>,
      portalContainer
    )
  ) : (
    <></>
  );
});
